// extracted by mini-css-extract-plugin
var _1 = "SettingsSectionFooter-module__container--Eu3Ao";
export { _1 as "container" }
